import cloneDeep from 'lodash/fp/cloneDeep'
import { listDifferenceComputer, modificationStates } from '../../../../../common/ReducerHelperFunctions/listDifferenceComputer'
import { validiateTextField } from '../../../../../common/forms/validationFunctions'

import {
  PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_ADD_NEW_EXPERIENCE
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_START_EDITING
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_STOP_EDITING
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_EDITING
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_MONTH
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_YEAR
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_MONTH
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_YEAR
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_END_DATE_CURRENT
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE_MODAL
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETING_EXPERIENCE
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETED_EXPERIENCE
  , PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_DELETING_EXPERIENCE
} from './pendingApprovalAdviserProfileWorkExperienceEditorActions.js'
import { events as containerEvents } from '../../AdviserProfileApprovalEditorContainer/adviserProfileApprovalEditorContainerActions'

const initialState = {
  loadingWorkExperience: false,
  editingWorkExperience: false,
  editingWorkExperienceIndex: -1,
  deletingWorkExperience: false,
  deletingWorkExperienceModal: false,
  deletingWorkExperienceIndex: -1,
  workExperiencesBeforeEditing: [],
  workExperiencesModifications: [],
  positionStartYear: null,
  positionStartMonth: null,
  positionEndYear: null,
  positionEndMonth: null,
  isInvalid: {
    formIsValid: true,
    position: {
      valid: true,
      isInvalid: false,
      message: null
    },
    company: {
      valid: true,
      isInvalid: false,
      message: null
    },
    startYear: {
      valid: true,
      isInvalid: false,
      message: null
    },
    startMonth: {
      valid: true,
      isInvalid: false,
      message: null
    },
    endYear: {
      valid: true,
      isInvalid: false,
      message: null
    },
    endMonth: {
      valid: true,
      isInvalid: false,
      message: null
    }
  }
}

const isFormValid = (state) => {
  const validationstate = state.experiences.isInvalid

  return (
    (validationstate.position.valid ?? true) &&
    (validationstate.company.valid ?? true) &&
    (validationstate.startYear.valid ?? true) &&
    (validationstate.endYear.valid ?? true) &&
    (validationstate.startMonth.valid ?? true) &&
    (validationstate.endMonth.valid ?? true)
  )
}
export default (state = initialState, action) => {
  var newState = copyWorkExperienceState(state)
  let date

  switch (action.type) {
    case containerEvents.fetch.fetched:
      newState.experiences.workExperiencesModifications = findWorkExperienceDifferences(newState)
      return newState
    case containerEvents.edit.cancel:
      newState.experiences = cloneDeep(initialState)
      newState.experiences.workExperiencesModifications = findWorkExperienceDifferences(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_ADD_NEW_EXPERIENCE:
        const currentDate = new Date(Date.now())
      const newExperience = {
        ...action.experience,
        modificationState: modificationStates.added,
        positionStartDate: currentDate.toISOString()
      }
      const updatedExperiences = [
        ...newState.experiences.workExperiencesModifications,
        newExperience
      ]
      newState.experiences = {
        ...newState.experiences,
        editingWorkExperience: true,
        editingWorkExperienceIndex: updatedExperiences.length - 1,
        workExperiencesBeforeEditing: cloneDeep(newState.experiences.workExperiencesModifications),
        workExperiencesModifications: updatedExperiences,
        isInvalid: {
          ...newState.experiences.isInvalid,
          position: { ...newState.experiences.isInvalid.position, valid: false },
          company: { ...newState.experiences.isInvalid.company, valid: false },
          startMonth: { ...newState.experiences.isInvalid.startMonth, valid: true },
          endMonth: { ...newState.experiences.isInvalid.endMonth, valid: true },
          startYear: { ...newState.experiences.isInvalid.startYear, valid: true },
          endYear: { ...newState.experiences.isInvalid.endYear, valid: true },
          // A newly added experience has no position or company yet, so the form cannot be
          // valid. isFormValid(newState) read the pre-update state and returned true.
          formIsValid: false
        },
        positionStartMonth: 0,
        positionStartYear: currentDate.getFullYear() - 1,
        positionEndMonth: 11,
        positionEndYear: currentDate.getFullYear()
      }
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_START_EDITING: {
  newState.experiences.editingWorkExperience = true
  newState.experiences.editingWorkExperienceIndex = action.index

  const startDate = new Date(
    newState.experiences.workExperiencesModifications[
      newState.experiences.editingWorkExperienceIndex
    ].positionStartDate
  )

  newState.experiences.positionStartMonth = startDate.getMonth()
  newState.experiences.positionStartYear = startDate.getFullYear()

  if (
    newState.experiences.workExperiencesModifications[
      newState.experiences.editingWorkExperienceIndex
    ].positionEndDate !== null
  ) {
    const endDate = new Date(
      newState.experiences.workExperiencesModifications[
        newState.experiences.editingWorkExperienceIndex
      ].positionEndDate
    )

    newState.experiences.positionEndMonth = endDate.getMonth()
    newState.experiences.positionEndYear = endDate.getFullYear()
  }

  newState.experiences.workExperiencesBeforeEditing =
    cloneDeep(newState.experiences.workExperiencesModifications)

  return newState
}
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_STOP_EDITING:
      newState.experiences.editingWorkExperience = false
      newState.experiences.editingWorkExperienceIndex = initialState.editingWorkExperienceIndex
      newState.experiences.positionStartMonth = initialState.positionStartMonth
      newState.experiences.positionStartYear = initialState.positionStartYear
      newState.experiences.positionEndMonth = initialState.positionEndMonth
      newState.experiences.positionEndYear = initialState.positionEndYear
      newState.experiences.isInvalid = cloneDeep(initialState.isInvalid)
      newState.pendingApprovalProfile.workExperiences = updateWorkExperiences(newState)
      newState.experiences.workExperiencesBeforeEditing = []
      newState.edited = true
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_EDITING:
      newState.experiences.editingWorkExperience = false
      newState.experiences.editingWorkExperienceIndex = initialState.editingWorkExperienceIndex
      newState.experiences.positionStartMonth = initialState.positionStartMonth
      newState.experiences.positionStartYear = initialState.positionStartYear
      newState.experiences.positionEndMonth = initialState.positionEndMonth
      newState.experiences.positionEndYear = initialState.positionEndYear
      newState.experiences.isInvalid = cloneDeep(initialState.isInvalid)
      newState.experiences.isInvalid.position = cloneDeep(initialState.isInvalid.position)
      newState.experiences.isInvalid.company = cloneDeep(initialState.isInvalid.company)
      newState.experiences.isInvalid.startYear = cloneDeep(initialState.isInvalid.startYear)
      newState.experiences.isInvalid.endYear = cloneDeep(initialState.isInvalid.endYear)
      newState.experiences.workExperiencesModifications = cloneDeep(newState.experiences.workExperiencesBeforeEditing)
      newState.experiences.workExperiencesBeforeEditing = []
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE:
      newState.experiences.workExperiencesModifications[newState.experiences.editingWorkExperienceIndex] = cloneDeep(action.experience)
      newState.experiences.isInvalid.position = validiateTextField(action.experience.position, 255, true)
      newState.experiences.isInvalid.company = validiateTextField(action.experience.company, 255, true)
      date = new Date(newState.experiences.workExperiencesModifications[newState.experiences.editingWorkExperienceIndex].positionStartDate)
      date.setMonth(newState.experiences.positionStartMonth)
      date.setFullYear(newState.experiences.positionStartYear)
      newState.experiences.workExperiencesModifications[newState.experiences.editingWorkExperienceIndex].positionStartDate = date.toISOString()
      if (!newState.experiences.workExperiencesModifications[newState.experiences.editingWorkExperienceIndex].isCurrentJob) {
        date = new Date(newState.experiences.workExperiencesModifications[newState.experiences.editingWorkExperienceIndex].positionEndDate)
        date.setMonth(newState.experiences.positionEndMonth)
        date.setFullYear(newState.experiences.positionEndYear)
        newState.experiences.workExperiencesModifications[newState.experiences.editingWorkExperienceIndex].positionEndDate = date.toISOString()
      }
      newState.experiences.isInvalid.position = action.validationResult.position
      newState.experiences.isInvalid.company = action.validationResult.company
      newState.experiences.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_MONTH:
      newState.experiences.positionStartMonth = action.month
      newState.experiences.isInvalid.startMonth = cloneDeep(action.validationResult)
      newState.experiences.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_START_YEAR:
      newState.experiences.positionStartYear = parseInt(action.year)
      newState.experiences.isInvalid.startYear = cloneDeep(action.validationResult)
      newState.experiences.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_MONTH:
      newState.experiences.positionEndMonth = action.month
      newState.experiences.isInvalid.endMonth = cloneDeep(action.validationResult)
      newState.experiences.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_EXPERIENCE_END_YEAR:
      newState.experiences.positionEndYear = parseInt(action.year)
      newState.experiences.isInvalid.endYear = cloneDeep(action.validationResult)
      newState.experiences.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_SET_END_DATE_CURRENT:
      if (!newState.experiences.workExperiencesModifications[newState.experiences.editingWorkExperienceIndex].isCurrentJob) {
        newState.experiences.workExperiencesModifications[newState.experiences.editingWorkExperienceIndex].positionEndDate = null
        newState.experiences.workExperiencesModifications[newState.experiences.editingWorkExperienceIndex].isCurrentJob = true
        newState.experiences.positionEndMonth = null
        newState.experiences.positionEndYear = null
        newState.experiences.isInvalid.endYear.valid = true
      } else {
        date = new Date(Date.now())
        newState.experiences.workExperiencesModifications[newState.experiences.editingWorkExperienceIndex].positionEndDate = date.toISOString()
        newState.experiences.workExperiencesModifications[newState.experiences.editingWorkExperienceIndex].isCurrentJob = false
        newState.experiences.positionEndMonth = date.getMonth()
        newState.experiences.positionEndYear = date.getFullYear()
        newState.experiences.isInvalid.endYear.valid = true
      }
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE:
      newState.experiences.workExperiencesModifications[newState.experiences.deletingWorkExperienceIndex].modificationState = modificationStates.deleted
      newState.pendingApprovalProfile.workExperiences = updateWorkExperiences(newState)
      newState.experiences.deletingWorkExperienceIndex = initialState.deletingWorkExperienceIndex
      newState.experiences.deletingWorkExperienceModal = false
      newState.edited = true
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETE_EXPERIENCE_MODAL:
      newState.experiences.deletingWorkExperienceIndex = action.index
      newState.experiences.deletingWorkExperienceModal = true
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETING_EXPERIENCE:
      newState.experiences.deletingWorkExperience = true
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_DELETED_EXPERIENCE:
      newState.experiences.deletingWorkExperience = false
      newState.edited = true
      return newState
    case PENDING_APPROVAL_ADVISER_WORK_EXPERIENCE_CANCEL_DELETING_EXPERIENCE:
      newState.experiences.deletingWorkExperienceIndex = initialState.deletingWorkExperienceIndex
      newState.experiences.deletingWorkExperienceModal = false
      return newState
  }

  return state
}

const updateWorkExperiences = (state) => {
  let modifications = cloneDeep(state.experiences.workExperiencesModifications.filter((experience) => experience.modificationState !== modificationStates.deleted))
  return modifications
}

const copyWorkExperienceState = (state) => {
  var newState = cloneDeep(state)
  newState.pendingApprovalProfile = cloneDeep(state.pendingApprovalProfile)
  if (state.pendingApprovalProfile) {
    newState.pendingApprovalProfile.workExperiences = cloneDeep(state.pendingApprovalProfile.workExperiences)
  }
  return newState
}

function workExperienceModified (oldItem, newItem, modifiedState, unModifiedState) {
  if (oldItem.position !== newItem.position ||
    oldItem.company !== newItem.company ||
    oldItem.positionStartDate !== newItem.positionStartDate ||
    oldItem.positionEndDate !== newItem.positionEndDate) {
    return modifiedState
  }

  return unModifiedState
}

function findWorkExperienceDifferences (state) {
  var modifications
  if (state.publishedProfile) {
    var oldList = state.publishedProfile.workExperiences
    var newList = state.pendingApprovalProfile.workExperiences
    modifications = listDifferenceComputer(oldList, newList, ['position', 'company', 'positionStartDate', 'positionEndDate'], workExperienceModified)
  }

  return modifications
}
